(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/objects/context-menu-handler.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/objects/context-menu-handler.js'); 
'use strict';

svs.maltipset.objects.ContextMenuHandler = Marionette.Object.extend({
  contextMenuData: {
    onTipsinfo: function() {
      svs.components.Modal.show(
        svs.maltipset.views.TipsInfo,
        {},
        {
          title: 'TIPSINFO',
          headerClass: 'maltipset-modal-header',
          leftButton: { visible: false },
          rightButton: {
            visible: true,
            text: 'Klar',
            cssClass: 'btn-transparent-inverted',
            callback: function() {
              this.model.set(this.checkBoxes);
              return true;
            }
          }
        }
      );
    },
    onSpelguide: function(event) {
      if (event) {
        event.preventDefault();
      }
      if (!svs.core.detect.feature('ft-maltipset-direct-play')) {
        this.openSpelguide();
      }
    },
    openSpelguide: function(startTab) {
      svs.components.Modal.show(
        svs.maltipset.views.Spelguide,
        { startTab: startTab },
        {
          title: 'Spelguide',
          headerClass: 'maltipset-modal-header',
          doubleWidth: !svs.core.detect.formfactor.mobile(),
          leftButton: {
            text: 'Stäng',
            visible: true,
            cssClass: 'btn-transparent-inverted'
          },
          rightButton: { visible: false }
        }
      );
    },
    showXperten: function() {
      svs.components.Modal.show(
        svs.maltipset.views.Xperten,
        { model: svs.maltipset.collections.coupons.getCurrentCoupon() },
        {
          title: 'XPERTEN',
          headerClass: 'maltipset-modal-header',
          leftButton: {
            text: 'Avbryt',
            visible: true,
            cssClass: 'btn-transparent-inverted'
          },
          rightButton: {
            text: 'Klar',
            visible: true,
            disabled: true,
            cssClass: 'btn-transparent-inverted',
            callback: function() {
              if (!this.changed) {
                return true;
              }

              var xpertObject = {
                xpertSize: this.systemSize,
                xpertSystem: this.useBaseRow
                  ? svs.maltipset.constants.XPERT_PROPERTIES.PARTIALQP
                  : svs.maltipset.constants.XPERT_PROPERTIES.WEIGHTEDQP
              };

              if (this.model.get('totalSelectedMatches') > 0) {
                var self = this,
                  dialog = new svs.components.dialog.Confirm({
                    branding: svs.components.dialog.branding.SPORT,
                    icon: 'help-2',
                    title: 'Dina tecken kommer att rensas',
                    message: [
                      {
                        type: svs.components.dialog.message.TEXT,
                        text: 'Vill du fortsätta ändå?'
                      }
                    ],
                    actions: [
                      {
                        title: 'Avbryt'
                      },
                      {
                        title: 'Fortsätt',
                        callback: function() {
                          dialog.close();
                          self.model.set(xpertObject);

                          if (self.useBaseRow) {
                            self.model.createBaseRow();
                          } else {
                            self.model.newXpert(false);
                          }
                        }
                      }
                    ]
                  });
                svs.components.dialog.api.add(dialog);
              } else {
                this.model.set(xpertObject);

                if (this.useBaseRow) {
                  this.model.createBaseRow();
                } else {
                  this.model.newXpert(false);
                }
              }

              return true;
            }
          }
        }
      );
    },
    onClearAll: function() {
      var dialog = new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.SPORT,
        icon: 'dustbin',
        title: 'Vill du rensa dina tecken?',
        actions: [
          {
            title: 'Avbryt'
          },
          {
            title: 'Fortsätt',
            callback: function() {
              dialog.close();
              svs.maltipset.collections.coupons.getCurrentCoupon().empty();
            }
          }
        ]
      });
      svs.components.dialog.api.add(dialog);
    },
    convertSystem: function(toSystem) {
      if (
        !svs.maltipset.collections.coupons
          .getCurrentCoupon()
          .canConvertToSystem(toSystem)
      ) {
        var dialog = new svs.components.dialog.Confirm({
          branding: svs.components.dialog.branding.SPORT,
          icon: 'help-2',
          title: 'Dina påbörjade rader kommer att rensas',
          message: [
            {
              type: svs.components.dialog.message.TEXT,
              text: 'Vill du fortsätta ändå?'
            }
          ],
          actions: [
            {
              title: 'Avbryt'
            },
            {
              title: 'Fortsätt',
              callback: function() {
                dialog.close();
                _.defer(function() {
                  svs.maltipset.collections.coupons
                    .getCurrentCoupon()
                    .changeSystem(toSystem);
                });
                svs.components.loader.show();
              }
            }
          ]
        });
        svs.components.dialog.api.add(dialog);
      } else {
        _.defer(function() {
          svs.maltipset.collections.coupons
            .getCurrentCoupon()
            .changeSystem(toSystem);
        });
        svs.components.loader.show();
      }
    },
    showSystemspel: function() {
      var self = this;
      svs.components.Modal.show(
        svs.maltipset.views.Systemspel,
        { model: svs.maltipset.collections.coupons.getCurrentCoupon() },
        {
          title: 'SYSTEMSPEL',
          headerClass: 'maltipset-modal-header',
          leftButton: {
            text: 'Avbryt',
            visible: true,
            cssClass: 'btn-transparent-inverted'
          },
          rightButton: {
            text: 'Klar',
            visible: true,
            cssClass: 'btn-transparent-inverted',
            callback: function() {
              if (this.changed) {
                self.convertSystem(this.selectedSystem);
              }
              return true;
            }
          }
        }
      );
    }
  },

  initContextMenu: function(options) {
    _.bindAll(this.contextMenuData, 'onSpelguide');
    this.isStartPage = options.isStartPage || false;
    this.hasDraws = _.isUndefined(options.hasDraws) ? true : options.hasDraws;
    var enableClearAll =
      options.enableClearAll &&
      svs.maltipset.collections.coupons.getCurrentCoupon().isEnabled() ||
      false;

    if (!_.isUndefined(svs.maltipset.data.spelguide)) {
      Backbone.history.navigate('/', { trigger: false });
      this.contextMenuData.openSpelguide(svs.maltipset.data.spelguide);
      delete svs.maltipset.data.spelguide;
    }

    if (this.isStartPage && svs.core.detect.formfactor.mobile()) {
      this.contextMenuData.menuType = 'button';
      this.contextMenuData.icon = 'icon-info';
      this.contextMenuData.surroundAnchor =
        svs.core.data.baseOriginalUrl + 'spelguide';
      this.contextMenuData.callback = this.contextMenuData.onSpelguide;
      this.contextMenuData.leftButtons = [];
      this.contextMenuData.rightButtons = [];
    } else if (this.hasDraws) {
      this.contextMenuData.menuType = 'menu';
      this.contextMenuData.leftButtonsInBlock = true;
      this.contextMenuData.icon = 'icon-nav-more-vertical';
      this.contextMenuData.leftButtons = [
        {
          text: 'Xperten',
          icon: 'icon-xperten',
          cssClass: 'contextual-menu-swipe-button-maltipset',
          callback: this.contextMenuData.showXperten,
          disabled:
            svs.maltipset.collections.coupons &&
            !svs.maltipset.collections.coupons.getCurrentCoupon().isEnabled()
        },
        {
          text: 'Tipsinfo',
          icon: 'icon-tipsinfo',
          cssClass: 'contextual-menu-swipe-button-maltipset',
          callback: this.contextMenuData.onTipsinfo,
          disabled:
            svs.maltipset.collections.coupons &&
            !svs.maltipset.collections.coupons.getCurrentCoupon().isEnabled()
        },
        {
          text: 'Systemspel',
          icon: 'icon-systemspel',
          cssClass: 'contextual-menu-swipe-button-maltipset',
          callback: this.contextMenuData.showSystemspel,
          disabled:
            svs.maltipset.collections.coupons &&
            !svs.maltipset.collections.coupons.getCurrentCoupon().isEnabled()
        }
      ];

      this.contextMenuData.rightButtons = [
        {
          text: 'Rensa',
          block: true,
          icon: 'icon-rensa-app',
          callback: this.contextMenuData.onClearAll,
          cssClass: 'contextual-menu-swipe-button-maltipset',
          disabled: !enableClearAll
        }
      ];
    }

    if (!svs.core.detect.formfactor.mobile()) {
      this.popover = undefined;
      this.showDesktopHeader();
    } else if (
      !this.isStartPage &&
      !svs.core.detect.feature('ft-maltipset-context-menu')
    ) {
      this.contextMenuData.rightButtons.push({
        text: 'Spelguide',
        disabled: false,
        id: 'maltipset-game-info',
        visible: svs.core.detect.formfactor.mobile(),
        action: this.contextMenuData.onSpelguide,
        callback: this.contextMenuData.onSpelguide
      });
      if (svs.core.detect.feature('ft-maltipset-direct-play')) {
        this.contextMenuData.rightButtons.pop();
      }
    }
    this.contextMenuData.useIconButtons = svs.core.detect.feature(
      'ft-maltipset-context-menu'
    );
    this.contextMenuData.contextScrollButtonClass =
      'contextual-menu-scroll-button-maltipset';
    this.contextMenuData.stickyMenuOffset = $(
      '.js-product-base-tabs-nav'
    ).height();
    this.contextMenuData.useFixedMenu = false;
    if (
      svs.core.detect.feature('ft-maltipset-context-menu') ||
      svs.core.detect.feature('ft-maltipset-direct-play')
    ) {
      this.contextMenuData.showMenuInHeader =
        options.showMenuInHeader || false;
    }
    svs.components.contextualMenu.setMenuFunctionality(this.contextMenuData);
  },
  openDrawSelectorPopOver: function() {
    var target = $('#maltipset-header-drawselector'),
      drawSelector = new svs.maltipset.views.DrawSelector({
        collection: svs.maltipset.collections.draws
      }),
      options = {
        content: drawSelector.render().el,
        branding: 'popover-maltipset',
        position: 'bottom',
        arrowoffset: -100,
        offset: {
          top: 2
        }
      };
    this.popover = new svs.components.Popover(target, options);
    this.popover.init();
    this.popover.show();
  },
  showDesktopHeader: function() {
    var config;

    if (!svs.core.detect.feature('ft-maltipset-direct-play')) {
      config = {
        title: {
          row1: {
            brand: 'maltipset',
            alt: 'Måltipset'
          }
        },
        rightButtons: [
          {
            cssClass: 'btn btn-100 btn-transparent-inverted',
            content: 'Spelguide',
            id: 'maltipset-game-info',
            action: this.contextMenuData.onSpelguide
          }
        ],
        leftButtons: []
      };
    } else {
      config = {
        title: {
          row1: {
            brand: 'maltipset',
            alt: 'Måltipset'
          }
        },
        rightButtons: [],
        leftButtons: []
      };
    }
    svs.core.template.updateConfig(config);
  }
});

 })(window);